/* Ovy Kinderwunsch-Landingpage */
(function () {
  var doc = document.documentElement;
  doc.classList.add('kw-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) doc.classList.add('kw-motion');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  ready(function () {
    /* ---------- Countdown: bis Aktionsende (falls gesetzt), sonst bis Mitternacht ---------- */
    var timers = document.querySelectorAll('[data-kw-countdown]');
    var endSetting = window.kwCampaignEnd ? new Date(window.kwCampaignEnd) : null;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = endSetting && !isNaN(endSetting) && endSetting > now ? endSetting : null;
      if (!end) { end = new Date(now); end.setHours(24, 0, 0, 0); }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400);
      var txt = (d > 0 ? d + (d === 1 ? ' Tag ' : ' Tage ') : '') + pad(Math.floor((s % 86400) / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      for (var i = 0; i < timers.length; i++) timers[i].textContent = txt;
    }
    if (timers.length) { tick(); setInterval(tick, 1000); }

    /* ---------- Headlines: Wort-für-Wort-Reveal ---------- */
    if (!reduce) {
      document.querySelectorAll('.kw-h1, .kw-h2, .kw-buy__title').forEach(function (h) {
        var idx = 0;
        (function wrap(node) {
          Array.prototype.slice.call(node.childNodes).forEach(function (c) {
            if (c.nodeType === 3) {
              var parts = c.textContent.split(/(\s+)/);
              var frag = document.createDocumentFragment();
              parts.forEach(function (p) {
                if (!p) return;
                if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
                var o = document.createElement('span'); o.className = 'kw-w';
                var i = document.createElement('span'); i.textContent = p; i.style.setProperty('--i', idx++);
                o.appendChild(i); frag.appendChild(o);
              });
              c.parentNode.replaceChild(frag, c);
            } else if (c.nodeType === 1) { wrap(c); }
          });
        })(h);
        h.setAttribute('data-kw-words', '');
      });
    }

    /* ---------- Stagger: Kinder bekommen Reveal + Verzögerung ---------- */
    document.querySelectorAll('[data-kw-stagger]').forEach(function (wrapEl) {
      var step = parseInt(wrapEl.getAttribute('data-kw-stagger'), 10) || 90;
      Array.prototype.forEach.call(wrapEl.children, function (c, i) {
        if (!c.hasAttribute('data-kw-reveal')) c.setAttribute('data-kw-reveal', '');
        c.style.transitionDelay = (i * step) + 'ms';
      });
    });

    /* ---------- Reveal-Observer ---------- */
    var revealEls = document.querySelectorAll('[data-kw-reveal], [data-kw-words], .kw-chart, .kw-cmp__box, [data-kw-count]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            if (e.target.hasAttribute('data-kw-count')) countUp(e.target);
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- Zahlen hochzählen ---------- */
    function countUp(el) {
      var raw = el.getAttribute('data-kw-final') || el.textContent;
      el.setAttribute('data-kw-final', raw);
      var m = raw.match(/(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d+))?/);
      if (!m) return;
      var intPart = m[1], dec = m[2] || '';
      var thousands = intPart.indexOf('.') > -1;
      var target = parseFloat(intPart.replace(/\./g, '') + (dec ? '.' + dec : ''));
      var pre = raw.slice(0, m.index), post = raw.slice(m.index + m[0].length);
      var t0 = null, dur = 1400;
      function fmt(v) {
        var s = dec ? v.toFixed(dec.length) : String(Math.round(v));
        var p = s.split('.'), ip = p[0];
        if (thousands) ip = ip.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return pre + ip + (p[1] ? ',' + p[1] : '') + post;
      }
      function frame(ts) {
        if (!t0) t0 = ts;
        var k = clamp((ts - t0) / dur, 0, 1);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt(target * e);
        if (k < 1) requestAnimationFrame(frame); else el.textContent = raw;
      }
      requestAnimationFrame(frame);
    }

    /* ---------- Hero: Auftritt beim Laden ---------- */
    var hero = document.querySelector('.kw-hero');
    if (hero) { requestAnimationFrame(function () { hero.classList.add('is-loaded'); }); setTimeout(function () { hero.classList.add('is-loaded'); }, 120); }

    /* ---------- Videos nur abspielen, wenn sichtbar ---------- */
    var vids = document.querySelectorAll('video[data-kw-autoplay]');
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { v.muted = true; vo.observe(v); });
    }

    /* ---------- Scroll-gekoppelte Effekte (Showcase, Parallax, Fortschritt) ---------- */
    var stage = document.querySelector('[data-kw-stage]');
    var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-kw-parallax]'));
    var bar = document.querySelector('.kw-progress');
    var ticking = false;
    var lastP = -1;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var vh = window.innerHeight;
        var y = window.scrollY;
        /* erst alles messen, dann schreiben (kein Layout-Thrashing) */
        var max = bar ? document.documentElement.scrollHeight - vh : 0;
        var sr = stage && !reduce ? stage.getBoundingClientRect() : null;
        var pr = reduce ? [] : parallax.map(function (el) { return el.getBoundingClientRect(); });
        if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max, 0, 1) : 0).toFixed(4) + ')';
        if (reduce) return;
        if (sr && sr.bottom > -100 && sr.top < vh + 100) {
          /* 0 = Stage kommt unten ins Bild, 1 = Stage-Mitte in Bildschirmmitte */
          var p = Math.round(clamp((vh - sr.top) / (vh * 0.5 + sr.height * 0.5), 0, 1) * 200) / 200;
          if (p !== lastP) {
            lastP = p;
            stage.style.setProperty('--kw-p', p.toFixed(3));
            stage.classList.toggle('is-docked', p > 0.92);
          }
        }
        parallax.forEach(function (el, i) {
          var r = pr[i];
          if (r.bottom < -200 || r.top > vh + 200) return;
          var f = parseFloat(el.getAttribute('data-kw-parallax')) || 0.08;
          var c = (r.top + r.height / 2 - vh / 2) * -f;
          el.style.setProperty('--kw-py', c.toFixed(1) + 'px');
        });
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* Showcase: Tilt bei Mausbewegung */
    if (stage && !reduce && window.matchMedia('(pointer: fine)').matches) {
      var rig = stage.querySelector('.kw-show__rig');
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        rig.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)';
      });
      stage.addEventListener('pointerleave', function () { rig.style.transform = ''; });
    }

    /* ---------- Galerie ---------- */
    document.querySelectorAll('[data-kw-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-kw-main]');
      g.querySelectorAll('[data-kw-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src');
          main.srcset = b.getAttribute('data-srcset') || '';
          g.querySelectorAll('[data-kw-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });

    /* ---------- Sticky-Bar nach dem Angebot ---------- */
    var sticky = document.querySelector('[data-kw-sticky]');
    var offer = document.getElementById('angebot');
    if (sticky && offer) {
      var foot = document.querySelector('.kw-foot');
      var update = function () {
        var r = offer.getBoundingClientRect();
        var past = r.bottom < 0;
        var atFoot = foot && foot.getBoundingClientRect().top < window.innerHeight - 40;
        sticky.classList.toggle('is-on', past && !atFoot);
        sticky.setAttribute('aria-hidden', past && !atFoot ? 'false' : 'true');
      };
      var sTick = false;
      window.addEventListener('scroll', function () { if (sTick) return; sTick = true; requestAnimationFrame(function () { sTick = false; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* ---------- Bewertungen einkürzen ---------- */
    var rev = document.querySelector('.shopify-section[id$="__reviews"]');
    if (rev) {
      rev.classList.add('kw-rev-clip');
      var more = document.createElement('div');
      more.className = 'kw-rev-more';
      more.innerHTML = '<button type="button" class="kw-btn kw-btn--ghost">Mehr Bewertungen lesen</button><a class="kw-btn kw-btn--rose" href="#angebot">Zum Angebot</a>';
      rev.parentNode.insertBefore(more, rev.nextSibling);
      more.querySelector('button').addEventListener('click', function () {
        rev.classList.add('is-open');
        this.remove();
      });
    }

    /* ---------- Kauf-Button: Doppelklick verhindern ---------- */
    document.querySelectorAll('[data-kw-buy]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var b = f.querySelector('button[type="submit"]');
        if (b) { b.disabled = true; b.dataset.label = b.innerHTML; b.innerHTML = 'Einen Moment …'; }
      });
    });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-kw-buy] button[type="submit"]').forEach(function (b) {
        b.disabled = false; if (b.dataset.label) b.innerHTML = b.dataset.label;
      });
    });
  });
})();
